import React from 'react';
import { Clock, Send, Plus } from 'lucide-react';
import { getTransactionIcon, getStatusBadge, isDebit } from './utils';

/**
 * Overview tab body: two quick-action cards + recent activity list.
 */
export default function OverviewTab({
  transactions,
  onTransfer,
  onAddAccount,
  onSend,
}) {
  return (
    <div className="space-y-6">
      <div className={`grid md:grid-cols-2 ${onSend ? 'lg:grid-cols-3' : ''} gap-4`}>
        <button
          type="button"
          onClick={onTransfer}
          className="flex items-center gap-4 p-5 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl border border-emerald-200 hover:shadow-md transition"
          data-testid="transfer-funds-btn"
        >
          <div className="p-3 bg-emerald-100 rounded-xl">
            <Send className="w-6 h-6 text-emerald-600" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-gray-900">Transfer to Bank</h3>
            <p className="text-sm text-gray-500">Withdraw funds to your bank account</p>
          </div>
        </button>
        {onSend && (
          <button
            type="button"
            onClick={onSend}
            className="flex items-center gap-4 p-5 bg-gradient-to-br from-purple-50 to-fuchsia-50 rounded-xl border border-purple-200 hover:shadow-md transition"
            data-testid="send-money-btn"
          >
            <div className="p-3 bg-purple-100 rounded-xl">
              <Send className="w-6 h-6 text-purple-600" />
            </div>
            <div className="text-left">
              <h3 className="font-semibold text-gray-900">Send Money</h3>
              <p className="text-sm text-gray-500">Send funds to another user&apos;s wallet</p>
            </div>
          </button>
        )}
        <button
          type="button"
          onClick={onAddAccount}
          className="flex items-center gap-4 p-5 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-200 hover:shadow-md transition"
          data-testid="add-account-btn"
        >
          <div className="p-3 bg-blue-100 rounded-xl">
            <Plus className="w-6 h-6 text-blue-600" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-gray-900">Add Bank Account</h3>
            <p className="text-sm text-gray-500">Link a new bank account or card</p>
          </div>
        </button>
      </div>

      <div>
        <h3 className="font-semibold text-gray-900 mb-3">Recent Activity</h3>
        {transactions.length === 0 ? (
          <div className="text-center py-8 bg-gray-50 rounded-xl">
            <Clock className="w-10 h-10 text-gray-400 mx-auto mb-2" />
            <p className="text-gray-500">No transactions yet</p>
          </div>
        ) : (
          <div className="space-y-2">
            {transactions.slice(0, 5).map((txn) => (
              <div key={txn._id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-white rounded-lg">
                    {getTransactionIcon(txn.type)}
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{txn.description}</p>
                    <p className="text-xs text-gray-500">{new Date(txn.created_at).toLocaleDateString()}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`font-semibold ${isDebit(txn.type) ? 'text-red-600' : 'text-green-600'}`}>
                    {isDebit(txn.type) ? '-' : '+'}${txn.amount.toFixed(2)}
                  </p>
                  {getStatusBadge(txn.status)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
